import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { redirect } from '../../common/utils/redirectionUtils'
import { connect } from 'react-redux'
import CloseIcon from '../../assets/CloseIcon'
import EditIcon from '../../assets/EditIcon'
import {
    HEADER_CONFIG,
    HEADER_CONST
} from '../../common/constant/common-constant'
import {
    PAGE_CONST,
    PERMISSION_FEATURE,
    PERMISSION_SCREEN,
    PERMISSION_TYPE,
    PLATFORM_CHARGES_STATUS,
    COMMISSION_EARNINGS_STATUS,
    PLATFORM_CHARGES_TAB,
    PROFILE_NAVIGATION_ITEMS
} from '../../common/constant/page-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import Card from '../Common/Card/Card'
import MobileHeader from '../Common/Header/MobileHeader'

import './PlatformCharges.scss'
import {
    getPlatformChargesHelper,
    payPlatformChargesHelper,
    updatePlatformChargesTransactionStatusHelper,
    getCommissionEarningsHelper,
    payCommissionEarningsHelper,
    updateCommissionTransactionStatusHelper
} from '../../helper/personal-details-helper'

const PlatformCharges = props => {
    const navigate = useNavigate()
    const isMobile = useCheckMobileScreen()

    const [searchParams, setSearchParams] = useSearchParams()
    const [headerOptions, setHeaderOptions] = useState({
        [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
        [HEADER_CONFIG.TITLE]: HEADER_CONST.PLATFORM_CHARGES,
        [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick()
    })
    const [permissions, setPermissions] = useState({})
    const [pcData, setPcData] = useState({})
    const [ceData, setCeData] = useState({})
    const [errMsg, setErrMsg] = useState(undefined)
    const [activeTab, setActiveTab] = useState(PLATFORM_CHARGES_TAB.PLATFORM_CHARGES)
    const [paymentResultPopup, setPaymentResultPopup] = useState({ show: false, success: false, message: '' })

    useEffect(() => {
        if (props.loginData.permissions) {
            let permission = props.loginData.permissions.filter(
                permission => permission.screen === PERMISSION_SCREEN.OTHER
            )[0]

            if (permission) setPermissions(permission)
        }
    }, [props.loginData])

    useEffect(() => {
        const handleParams = async () => {
            const rawData = searchParams?.get('data')
            const data = rawData?.replace(/ /g, '+') // fix for base64 with `+` issue
            const paymentType = localStorage.getItem('pending_payment_type')
            const typeParam = searchParams?.get('type')

            console.log('params data: ', data, 'type:', typeParam, 'paymentType:', paymentType)

            if (data) {
                localStorage.removeItem('pending_payment_type')
                const isCommission = paymentType === 'commission_earnings' || typeParam === 'commission'

                if (isCommission) {
                    setActiveTab(PLATFORM_CHARGES_TAB.COMMISSION_EARNINGS)
                    await updateCommissionTransactionStatus(data)
                } else {
                    setActiveTab(PLATFORM_CHARGES_TAB.PLATFORM_CHARGES)
                    await updatePlatformChargesTransactionStatus(data)
                }

                const newParams = new URLSearchParams(searchParams)
                newParams.delete('data')
                newParams.delete('type')
                setSearchParams(newParams, { replace: true })
            }
        }

        handleParams()
    }, [searchParams])

    useEffect(() => {
        getPlatformCharges()
        getCommissionEarnings()
    }, [])

    const getPlatformCharges = async () => {
        let data = await getPlatformChargesHelper()

        setPcData(data)
        console.log('platform charges data: ', data)
    }

    const getCommissionEarnings = async () => {
        try {
            let data = await getCommissionEarningsHelper()

            setCeData(data)
            console.log('commission earnings data: ', data)
        } catch (err) {
            console.log('error fetching commission earnings: ', err)
        }
    }

    const getPlatformChargeStatus = pcItem => {
        let text = ''
        let color = ''

        if (pcItem?.status === PLATFORM_CHARGES_STATUS.PAID) {
            text = 'Paid'
            color = 'textGreen'
        } else if (pcItem?.status === PLATFORM_CHARGES_STATUS.PENDING) {
            text = 'Pending'
            color = 'primaryText'
        }

        return {
            text,
            color
        }
    }

    const getCommissionEarningStatus = ceItem => {
        let text = ''
        let color = ''

        if (ceItem?.status === COMMISSION_EARNINGS_STATUS.PAID) {
            text = 'Paid'
            color = 'textGreen'
        } else if (ceItem?.status === COMMISSION_EARNINGS_STATUS.PENDING) {
            text = 'Pending'
            color = 'primaryText'
        }

        return {
            text,
            color
        }
    }

    const payPlatformCharges = async () => {
        const redirectUrl = window.location.origin + '/profile'
        try {
            let data = await payPlatformChargesHelper(redirectUrl)

            console.log('data: ', data)
            if (data?.payment_url) {
                localStorage.setItem('pending_payment_type', 'platform_charges')
                window.location.href = data.payment_url
            }
        } catch (err) {
            console.log('error in fetching payment url: ', err)
            setPaymentResultPopup({ show: true, success: false, message: err || 'Payment gateway is not working at the moment.' })
        }
    }

    const payCommissionEarnings = async () => {
        const redirectUrl = window.location.origin + '/profile'
        try {
            let data = await payCommissionEarningsHelper(redirectUrl)

            console.log('data: ', data)
            if (data?.payment_url) {
                localStorage.setItem('pending_payment_type', 'commission_earnings')
                window.location.href = data.payment_url
            }
        } catch (err) {
            console.log('error in fetching commission payment url: ', err)
            setPaymentResultPopup({ show: true, success: false, message: err || 'Payment gateway is not working at the moment.' })
        }
    }

    const updatePlatformChargesTransactionStatus = async data => {
        try {
            let res = await updatePlatformChargesTransactionStatusHelper(data)

            console.log('update PC TransactionStatus: ', res)
            getPlatformCharges()
            if (res?.txn_status === 'SUCCESS') {
                setPaymentResultPopup({ show: true, success: true, message: 'Payment has been completed successfully.' })
            } else {
                setPaymentResultPopup({ show: true, success: false, message: 'Payment ' + (res?.txn_status || 'could not be verified') + '. Please try again.' })
            }
        } catch (err) {
            console.log('update PC TransactionStatus error: ', err)
            setPaymentResultPopup({ show: true, success: false, message: err || 'Failed to verify payment status.' })
        }
    }

    const updateCommissionTransactionStatus = async data => {
        try {
            let res = await updateCommissionTransactionStatusHelper(data)

            console.log('update CE TransactionStatus: ', res)
            getCommissionEarnings()
            if (res?.txn_status === 'SUCCESS') {
                setPaymentResultPopup({ show: true, success: true, message: 'Payment has been completed successfully.' })
            } else {
                setPaymentResultPopup({ show: true, success: false, message: 'Payment ' + (res?.txn_status || 'could not be verified') + '. Please try again.' })
            }
        } catch (err) {
            console.log('update CE TransactionStatus error: ', err)
            setPaymentResultPopup({ show: true, success: false, message: err || 'Failed to verify payment status.' })
        }
    }

    const handlePayNow = () => {
        if (activeTab === PLATFORM_CHARGES_TAB.PLATFORM_CHARGES) {
            payPlatformCharges()
        } else {
            payCommissionEarnings()
        }
    }

    const showPayNowButton = () => {
        if (activeTab === PLATFORM_CHARGES_TAB.PLATFORM_CHARGES) {
            return permissions?.features?.[PERMISSION_FEATURE.PLATFORM_CHARGES] === PERMISSION_TYPE.MANAGE &&
                pcData?.total_due_platform_charges > 0
        } else {
            return permissions?.features?.[PERMISSION_FEATURE.PLATFORM_CHARGES] === PERMISSION_TYPE.MANAGE &&
                ceData?.total_due_commission > 0
        }
    }

    const renderPlatformChargesContent = () => (
        <>
            <div className="consolidateStrip dFlex aiCenter rowReverse">
                <div className="consolidateData">
                    {`BDT ${pcData?.total_due_platform_charges || 0}`}
                </div>
                <div className="consolidateDataText">
                    Total Due Platform Charges
                    <small className="weightNormal">
                        Platform charges are due by the 5th of the following
                        month{' '}
                    </small>{' '}
                </div>
            </div>
            <div className="productLlistWrap dFlex">
                {pcData?.items?.map((pcItem, index) => {
                    return (
                        <div className="cardWrap" key={`pc-${index}`}>
                            <Card
                                cardRight={`BDT ${pcItem?.charges}`}
                                headerSup={`Payment Date: ${
                                    pcItem?.paid_at || ''
                                }`}
                                headerMain={pcItem?.month}
                                sales={`Txn Reference No.: ${pcItem?.txn_reference_no || '-'}`}
                                orderStatus={getPlatformChargeStatus(
                                    pcItem
                                )}
                            />
                        </div>
                    )
                })}
            </div>
        </>
    )

    const renderCommissionEarningsContent = () => (
        <>
            <div className="consolidateStrip dFlex aiCenter rowReverse">
                <div className="consolidateData">
                    {`BDT ${ceData?.total_due_commission || 0}`}
                </div>
                <div className="consolidateDataText">
                    Total Due Commission Earnings
                    <small className="weightNormal">
                        Commission rate: {ceData?.commission_rate || 0}%
                    </small>{' '}
                </div>
            </div>
            <div className="productLlistWrap dFlex">
                {ceData?.items?.map((ceItem, index) => {
                    return (
                        <div className="cardWrap" key={`ce-${index}`}>
                            <Card
                                cardRight={`BDT ${ceItem?.commission}`}
                                headerSup={`Payment Date: ${
                                    ceItem?.paid_at || ''
                                }`}
                                headerMain={ceItem?.month}
                                sales={
                                    <>
                                        <div>Total Sales: BDT {ceItem?.total_sales || 0}</div>
                                        <div>Txn Reference No.: {ceItem?.txn_reference_no || '-'}</div>
                                    </>
                                }
                                orderStatus={getCommissionEarningStatus(
                                    ceItem
                                )}
                            />
                        </div>
                    )
                })}
            </div>
        </>
    )

    return (
        <>
            {isMobile && <MobileHeader headerOptions={headerOptions} />}
            <div className="pageBodyRightPanel">
                {isMobile && showPayNowButton() && (
                    <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
                        <button
                            className="btn btnPrimary lhauto"
                            onClick={handlePayNow}>
                            Pay Now
                        </button>
                    </div>
                )}
                {!isMobile && (
                    <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
                        <div className="pageBodyRightPanelHeading">
                            Platform Charges / Commission Earnings
                        </div>
                        <div className="addProductBtn dFlex aiCenter">
                            {showPayNowButton() && (
                                <button
                                    className="btn btnPrimary"
                                    onClick={handlePayNow}>
                                    Pay Now
                                </button>
                            )}
                        </div>
                    </div>
                )}
                {errMsg && (
                    <div className="invalidFeedback textRight">{errMsg}</div>
                )}

                {paymentResultPopup.show && (
                    <div className="popupWrap" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                        <div style={{ background: '#fff', borderRadius: '12px', padding: '32px', maxWidth: '400px', width: '90%', textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>
                                {paymentResultPopup.success ? '✓' : '✕'}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px', color: paymentResultPopup.success ? '#28a745' : '#dc3545' }}>
                                {paymentResultPopup.success ? 'Payment Successful' : 'Payment Failed'}
                            </div>
                            <div style={{ fontSize: '14px', color: '#666', marginBottom: '24px' }}>
                                {paymentResultPopup.message}
                            </div>
                            <button
                                className="btn btnPrimary"
                                onClick={() => setPaymentResultPopup({ show: false, success: false, message: '' })}
                                style={{ minWidth: '120px' }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                )}
                
                {/* Tab Navigation */}
                <div className="platformChargesWrapper mt-5">
                    <ul className="tabs dFlex">
                        <li
                            className={`tabItem ${
                                activeTab === PLATFORM_CHARGES_TAB.PLATFORM_CHARGES
                                    ? 'active'
                                    : ''
                            }`}
                            onClick={() =>
                                setActiveTab(PLATFORM_CHARGES_TAB.PLATFORM_CHARGES)
                            }>
                            Platform Charges
                        </li>
                        <li
                            className={`tabItem ${
                                activeTab === PLATFORM_CHARGES_TAB.COMMISSION_EARNINGS
                                    ? 'active'
                                    : ''
                            }`}
                            onClick={() =>
                                setActiveTab(PLATFORM_CHARGES_TAB.COMMISSION_EARNINGS)
                            }>
                            Commission Earnings
                        </li>
                    </ul>
                    <div className="tabContent">
                        {activeTab === PLATFORM_CHARGES_TAB.PLATFORM_CHARGES && renderPlatformChargesContent()}
                        {activeTab === PLATFORM_CHARGES_TAB.COMMISSION_EARNINGS && renderCommissionEarningsContent()}
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        loginData: state.loginDataReducer?.loginData
    }
}
const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PlatformCharges)
